export const tryOrGet = (/** @type {() => any} */ func, /** @type {any} */ defaultValue) => {
  try {
    return func()
  } catch {
    return defaultValue
  }
}

export const numberFormatCompact = (/** @type {number | bigint} */ value) =>
  Intl.NumberFormat('en-US', { notation: 'compact', compactDisplay: 'short' }).format(value)

export const sleep = (/** @type {number} */ ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const getNumberOr = (/** @type {number} */ number, /** @type {number} */ defaultNumber) => Number.isFinite(number) ? number : defaultNumber